"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _createTranslator = _interopRequireDefault(require("./create-translator"));
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var DEFAULT_LOCALE = 'en';
var baseTranslator = function baseTranslator(key) {
  return key;
};
var _default = function _default(_translations) {
  var Translator = /*#__PURE__*/function (_Component) {
    (0, _inherits2["default"])(Translator, _Component);
    var _super = _createSuper(Translator);
    function Translator() {
      (0, _classCallCheck2["default"])(this, Translator);
      return _super.apply(this, arguments);
    }
    (0, _createClass2["default"])(Translator, [{
      key: "render",
      value: function render() {
        var contextLocale = this.context && this.context.locale;
        if (!contextLocale) {
          console.warn('[js-translations] missing locale in the context. Check your translations Provider.');
        }
        var locale = contextLocale || DEFAULT_LOCALE;
        var translations = this.context && this.context.translations || _translations;
        var t = translations ? (0, _createTranslator["default"])(translations, locale) : baseTranslator;
        return this.props.children(t);
      }
    }]);
    return Translator;
  }(_react.Component);
  Translator.contextTypes = {
    locale: _propTypes["default"].string,
    translations: _propTypes["default"].object
  };
  Translator.propTypes = {
    children: _propTypes["default"].func.isRequired
  };
  return Translator;
};
exports["default"] = _default;